import { refreshUserHeader } from './db.js';

export const USERS = ['kenny', 'cassidy'];
const USER_LABELS = { kenny: 'Kenny', cassidy: 'Cassidy' };

export function isLoggedIn() {
  const u = localStorage.getItem('grit-user');
  if (u && !USERS.includes(u)) { localStorage.removeItem('grit-user'); localStorage.removeItem('grit-viewing'); } // a removed user (Christian) signs out cleanly
  if (localStorage.getItem('grit-viewing') && !USERS.includes(localStorage.getItem('grit-viewing'))) localStorage.setItem('grit-viewing', u || '');
  return USERS.includes(u);
}

export function activeUser() {
  return localStorage.getItem('grit-user') || null;
}

export function login(user) {
  if (!USERS.includes(user)) return;
  localStorage.setItem('grit-user', user);
  localStorage.setItem('grit-viewing', user);
  refreshUserHeader();
  applyTheme();
}

export function logout() {
  localStorage.removeItem('grit-user');
  localStorage.removeItem('grit-viewing');
  applyTheme();
}

// Cross-view: which user's data we're *looking at* (read-only). Defaults to self.
export function viewing() {
  return localStorage.getItem('grit-viewing') || activeUser();
}

export function setViewing(user) {
  if (USERS.includes(user)) localStorage.setItem('grit-viewing', user);
}

export function isViewingSelf() {
  return viewing() === activeUser();
}

export function label(user) {
  return USER_LABELS[user] || user || '';
}

// Each athlete's colour. "brand" is for big shapes (bars, rings); "deep" is the
// shade that white text and small text can sit on (4.5:1 or better); "soft" is a tint.
const COLORS = {
  kenny: { brand: '#EC7726', deep: '#C45100', text: '#A84D0E', soft: '#FDEEE2' },
  cassidy: { brand: '#8DA47E', deep: '#5A7350', text: '#4D6644', soft: '#EEF3EA' },
};
export function userColor(user) { return COLORS[user] || COLORS.kenny; }

// The whole app takes the signed-in person's colour (Cassidy: sage). See :root in style.css.
const THEMES = { cassidy: 'sage' };
export function applyTheme() {
  const t = THEMES[activeUser()];
  if (t) document.documentElement.dataset.theme = t; else delete document.documentElement.dataset.theme;
}
